export default {
  "brand": "AdsCanal",
  "domain": "www.adscanal.com",
  "email": "contact@adscanal.com",
  "linkedin": "https://www.linkedin.com/company/adscanal",
  "initials": "A",
  "eyebrow": "Performance Media Partner",
  "headline": "Scale app growth with programmatic execution built for accountable performance.",
  "description": "Created for advertiser teams that need disciplined campaign operations, dependable supply access, and a clearer line from media activity to business outcomes.",
  "metrics": [
    {
      "value": "Cross-market",
      "label": "Campaign reach"
    },
    {
      "value": "Rapid",
      "label": "Launch cycles"
    },
    {
      "value": "Practical",
      "label": "Optimization support"
    }
  ],
  "capabilities": [
    {
      "title": "Global Media Access",
      "text": "Activate campaigns across diversified traffic sources with better supply qualification before spend accelerates."
    },
    {
      "title": "Testing Discipline",
      "text": "Structure launch plans around creative learning, source validation, and measurable decision points."
    },
    {
      "title": "Audience Strategy",
      "text": "Refine targeting through market signals, cohort patterns, and conversion-quality feedback."
    },
    {
      "title": "Campaign Governance",
      "text": "Coordinate budgets, pacing, and partner communication with fewer black-box assumptions."
    }
  ],
  "solutions": [
    {
      "tag": "For Advertisers",
      "title": "Acquire users with tighter operational control",
      "text": "Move faster on tests, isolate stronger supply, and scale campaigns with clearer performance guardrails.",
      "points": [
        "Structured source testing",
        "Creative and funnel feedback loops",
        "Commercial models that fit performance teams"
      ]
    },
    {
      "tag": "For Media Partners",
      "title": "Connect quality traffic to dependable spend",
      "text": "Build long-term delivery relationships around visibility, communication speed, and practical optimization.",
      "points": [
        "Consistent partner communication",
        "Volume planning with quality review",
        "Smoother handoff between ops and account teams"
      ]
    }
  ],
  "workflow": [
    "Define performance targets, geo priorities, and source constraints.",
    "Launch controlled tests across vetted traffic and creative combinations.",
    "Scale through tighter budget allocation and partner-level learnings."
  ],
  "trust": [
    "App installs",
    "Performance commerce",
    "Lead generation",
    "Subscription products",
    "Emerging markets",
    "Global campaigns"
  ],
  "companyLine": "AdsCanal is an operating partner for teams that want cleaner media execution and stronger commercial clarity.",
  "footerText": "AdsCanal helps advertisers, publishers, and media teams run with more confidence across acquisition, monetization, and partner operations.",
  "palette": {
    "primary": "#6a5cff",
    "secondary": "#2ec5ff",
    "accent": "#d8dcff"
  }
};
